export const data1_3_default = [{
    name: `Rooms Revenue (+/-5%) <br />客房收入(正负百分之五范围内, 否则需要做出解释）`,
    name_code: "Rooms_Revenue",
    mtd_percent: 0, //月累计百分比
    mtd_note: '',    //月累计备注
    ytd_percent: 0,  //年累计百分比
    ytd_note: '',     //年累计备注
    threemonth_percent: 0, //后三个月滚动预测
    threemonth_note: '', //后三个月滚动预测备注
    wholeyear_budget_percent: 0, //整年预测对比预算百分比
    wholeyear_budget_note: '', //整年预测对比预算备注
    wholeyear_lastyear_percent: 0, //整年预测对比去年百分比
    wholeyear_lastyear_note: '', //整年预测对比去年备注  
}, {
    name: `F&B Revenue (+/-5%) <br />餐饮收入(正负百分之五范围内, 否则需要做出解释）`,
    name_code: "FB_Revenue",
    mtd_percent: 0, //月累计百分比
    mtd_note: '',    //月累计备注
    ytd_percent: 0,  //年累计百分比
    ytd_note: '',     //年累计备注
    threemonth_percent: 0, //后三个月滚动预测
    threemonth_note: '', //后三个月滚动预测备注
    wholeyear_budget_percent: 0, //整年预测对比预算百分比
    wholeyear_budget_note: '', //整年预测对比预算备注
    wholeyear_lastyear_percent: 0, //整年预测对比去年百分比
    wholeyear_lastyear_note: '', //整年预测对比去年备注  
}, {
    name: `Others Revenue (+/-5%) <br />其他收入(正负百分之五范围内, 否则需要做出解释）`,
    name_code: "Others_Revenue",
    mtd_percent: 0, //月累计百分比
    mtd_note: '',    //月累计备注
    ytd_percent: 0,  //年累计百分比
    ytd_note: '',     //年累计备注
    threemonth_percent: 0, //后三个月滚动预测
    threemonth_note: '', //后三个月滚动预测备注
    wholeyear_budget_percent: 0, //整年预测对比预算百分比
    wholeyear_budget_note: '', //整年预测对比预算备注
    wholeyear_lastyear_percent: 0, //整年预测对比去年百分比
    wholeyear_lastyear_note: '', //整年预测对比去年备注  
}, {
    name: `Total Revenue (+/-5%)<br />总收入(正负百分之五范围内）(正负百分之五范围内, 否则需要做出解释`,
    name_code: "Total_Revenue",
    mtd_percent: 0, //月累计百分比
    mtd_note: '',    //月累计备注
    ytd_percent: 0,  //年累计百分比
    ytd_note: '',     //年累计备注
    threemonth_percent: 0, //后三个月滚动预测
    threemonth_note: '', //后三个月滚动预测备注
    wholeyear_budget_percent: 0, //整年预测对比预算百分比
    wholeyear_budget_note: '', //整年预测对比预算备注
    wholeyear_lastyear_percent: 0, //整年预测对比去年百分比
    wholeyear_lastyear_note: '', //整年预测对比去年备注  
}, {
    name: `Rooms Dep't Profit % <br />客房部门利润率(小于百分之七十需要做出解释）`,
    name_code: "Rooms_Dept_Profit",
    mtd_percent: 0, //月累计百分比
    mtd_note: '',    //月累计备注
    ytd_percent: 0,  //年累计百分比
    ytd_note: '',     //年累计备注
    threemonth_percent: 0, //后三个月滚动预测
    threemonth_note: '', //后三个月滚动预测备注
    wholeyear_budget_percent: 0, //整年预测对比预算百分比
    wholeyear_budget_note: '', //整年预测对比预算备注
    wholeyear_lastyear_percent: 0, //整年预测对比去年百分比
    wholeyear_lastyear_note: '', //整年预测对比去年备注  
}, {
    name: `F&B Dep't Profit %  <br />餐饮部门利润率（小于百分之三十需要做出解释）`,
    name_code: "FB_Dept_Profit",
    mtd_percent: 0, //月累计百分比
    mtd_note: '',    //月累计备注
    ytd_percent: 0,  //年累计百分比
    ytd_note: '',     //年累计备注
    threemonth_percent: 0, //后三个月滚动预测
    threemonth_note: '', //后三个月滚动预测备注
    wholeyear_budget_percent: 0, //整年预测对比预算百分比
    wholeyear_budget_note: '', //整年预测对比预算备注
    wholeyear_lastyear_percent: 0, //整年预测对比去年百分比
    wholeyear_lastyear_note: '', //整年预测对比去年备注  
}, {
    name: `F&B Total Cost % <br />食品及饮品成本率（大于百分之三十五需要做出解释）`,
    name_code: "Revenue",
    mtd_percent: 0, //月累计百分比
    mtd_note: '',    //月累计备注
    ytd_percent: 0,  //年累计百分比
    ytd_note: '',     //年累计备注
    threemonth_percent: 0, //后三个月滚动预测
    threemonth_note: '', //后三个月滚动预测备注
    wholeyear_budget_percent: 0, //整年预测对比预算百分比
    wholeyear_budget_note: '', //整年预测对比预算备注
    wholeyear_lastyear_percent: 0, //整年预测对比去年百分比
    wholeyear_lastyear_note: '', //整年预测对比去年备注  
}, {
    name: `Total Payroll Cost % <br />人力资源总成本率（大于百分之三十需要做出解释）`,
    name_code: "Total_Payroll_Cost",
    mtd_percent: 0, //月累计百分比
    mtd_note: '',    //月累计备注
    ytd_percent: 0,  //年累计百分比
    ytd_note: '',     //年累计备注
    threemonth_percent: 0, //后三个月滚动预测
    threemonth_note: '', //后三个月滚动预测备注
    wholeyear_budget_percent: 0, //整年预测对比预算百分比
    wholeyear_budget_note: '', //整年预测对比预算备注
    wholeyear_lastyear_percent: 0, //整年预测对比去年百分比
    wholeyear_lastyear_note: '', //整年预测对比去年备注  
}, {
    name: `Utility Cost %  (>10%, Act>Fcst or LY) <br />能源成本率（大于百分之十需要做出解释）`,
    name_code: "Utility_Cost",
    mtd_percent: 0, //月累计百分比
    mtd_note: '',    //月累计备注
    ytd_percent: 0,  //年累计百分比
    ytd_note: '',     //年累计备注
    threemonth_percent: 0, //后三个月滚动预测
    threemonth_note: '', //后三个月滚动预测备注
    wholeyear_budget_percent: 0, //整年预测对比预算百分比
    wholeyear_budget_note: '', //整年预测对比预算备注
    wholeyear_lastyear_percent: 0, //整年预测对比去年百分比
    wholeyear_lastyear_note: '', //整年预测对比去年备注  
}, {
    name: `Other Expense and Cost  (+/-5%) <br />其他费用及成本(正负百分之五范围内）`,
    name_code: "Other_Expense_Cost",
    mtd_percent: 0, //月累计百分比
    mtd_note: '',    //月累计备注
    ytd_percent: 0,  //年累计百分比
    ytd_note: '',     //年累计备注
    threemonth_percent: 0, //后三个月滚动预测
    threemonth_note: '', //后三个月滚动预测备注
    wholeyear_budget_percent: 0, //整年预测对比预算百分比
    wholeyear_budget_note: '', //整年预测对比预算备注
    wholeyear_lastyear_percent: 0, //整年预测对比去年百分比
    wholeyear_lastyear_note: '', //整年预测对比去年备注  
}, {
    name: `GOP % <br />经营毛利率（若是实际不能达到标准边际利润率则需出解释）`,
    name_code: "GOP",
    mtd_percent: 0, //月累计百分比
    mtd_note: '',    //月累计备注
    ytd_percent: 0,  //年累计百分比
    ytd_note: '',     //年累计备注
    threemonth_percent: 0, //后三个月滚动预测
    threemonth_note: '', //后三个月滚动预测备注
    wholeyear_budget_percent: 0, //整年预测对比预算百分比
    wholeyear_budget_note: '', //整年预测对比预算备注
    wholeyear_lastyear_percent: 0, //整年预测对比去年百分比
    wholeyear_lastyear_note: '', //整年预测对比去年备注  
}, {
    name: `Standard Flow Thru`,
    name_code: "Standard_Flow_Thru",
    mtd_percent: 0, //月累计百分比
    mtd_note: '',    //月累计备注
    ytd_percent: 0,  //年累计百分比
    ytd_note: '',     //年累计备注
    threemonth_percent: 0, //后三个月滚动预测
    threemonth_note: '', //后三个月滚动预测备注
    wholeyear_budget_percent: 0, //整年预测对比预算百分比
    wholeyear_budget_note: '', //整年预测对比预算备注
    wholeyear_lastyear_percent: 0, //整年预测对比去年百分比
    wholeyear_lastyear_note: '', //整年预测对比去年备注  
}]


// WEBPACK FOOTER //
// ./src/components/table/1-KPI/1-3/data.js